/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Typography} from '@mui/material';

const ArgosErrorMessage = () => {
  return (
    <div>
      <Typography style={{fontSize: "25px"}}>
        Oops, an error has ocurred. Please reload the page or contact the Argos Team
      </Typography>
    </div>
  )
}
export default ArgosErrorMessage;